import React from 'react';
import { Button } from 'react-bootstrap';

function BlockUi(props) {
  const {
    type = '',
    blocking = false,
    message = 'Actualice su plan para obtener esta caracterisitica',
    children,
    onClick = () => window.location.href = "/es/prices/index"
  } = props

  return (
    <div className={`block-ui ${type}`}>
      {children}
      {blocking && <div className="block-ui-container">
        <div className="block-ui-overlay" />
        <p className="block-ui-message-container">
          {type !== 'single' && message}
          <Button bsStyle="warning" bsSize="small" onClick={onClick}>
            PREMIUM
          </Button>
        </p>
      </div>}
    </div>
  )
}

export default BlockUi;